<div [ngClass]="assignMode ? 'assign-header' : 'channels-header'">
  <h1
    class="channels-header__title"
    [ngClass]="{ 'assign-mode': assignMode }"
    data-testId="channels-title"
  >
    {{ assignMode ? 'Assign new station' : 'Stations'}}
  </h1>

  <div
    class="channels-header__search"
    (focusout)="onFocusOutEvent($event)"
    [ngClass]="searchOpen ? 'expand-search' : ''"
  >
    <mat-icon
      aria-hidden="false"
      class="material-symbols-outlined"
      aria-label="Search icon"
      fontIcon="search"
      (click)="clickEvent()"
      data-testId="channel-search-icon"
    ></mat-icon>
    <input 
      type="text" 
      data-testId="channels-search-input" 
      #userSearch
      [(ngModel)]="searchValue"
      (input)="keyPressed($event)" />
  </div>

  <div *ngIf="!assignMode" class="hr-line mb-3"><div class="hr-line__inside"></div></div>

  <app-screen-container>
    <div class="row">
      <div class="col-lg-12 d-flex justify-content-end">
        <app-add-button
          matTooltip="Add station"
          data-testId="create-channel-button"
          [disabled]="disableAddButton"
          (onClick)="openCreateChannelsDialog()"
        >
        </app-add-button>
      </div>
    </div>
  </app-screen-container>
</div>
